const pgcetmbaGeneralKnowledge = [
  {
    id: 81,
    question: "A sum of ₹8,000 amounts to ₹9,800 in 3 years at simple interest. What would be the amount if the rate of interest is increased by 2%?",
    options: ["A. ₹10,280", "B. ₹10,400", "C. ₹10,180", "D. ₹10,320"],
    answer: "A"
  },
  {
    id: 82,
    question: "Find the mean and median of the following data: 8, 12, 15, 10, 20, 18, 9",
    options: [
      "A. Mean = 13.14, Median = 12",
      "B. Mean = 12, Median = 13.14",
      "C. Mean = 13.14, Median = 15",
      "D. Mean = 12.86, Median = 12"
    ],
    answer: "A"
  },
  {
    id: 83,
    question: "In a class of 50 students, 60% passed in Mathematics and 70% passed in English. If 40% passed in both subjects, what percentage of students failed in both subjects?",
    options: ["A. 5%", "B. 10%", "C. 15%", "D. 20%"],
    answer: "B"
  },
  {
    id: 84,
    question : "Two pipes A and B can fill a tank in 15 hours and 20 hours respectively, while a third pipe C can empty the full tank in 25 hours. If all three pipes are opened together, how long will it take to fill the tank?",
    options : ["A. 13.04 hours", "B. 11.2 hours", "C. 12.1 hours", "D. 10.9 hours"],
    answer : "A"
  },
  {
    id: 85,
    question: "The correlation coefficient between two variables X and Y is not affected by: (i) Interchanging the two variables (ii) Adding the same constant to all values of one variable (iii) Multiplying all values of one variable by the same negative number",
    options: ["A. (i) and (ii) only", "B. (ii) and (iii) only", "C. (i), (ii) and (iii)", "D. None of the above"],
    answer: "A"
  },
  {
    id: 86,
    question: "The average of 20 numbers is 45. If the average of the first 12 numbers is 40 and that of the last 8 numbers is 52, is this data consistent?",
    options: [
      "A. Yes, exactly consistent",
      "B. No, the actual average would be 45.2",
      "C. No, the actual average would be 44.8",
      "D. Cannot be determined"
    ],
    answer: "C"
  },
  {
    id: 87,
    question: "What is the compound interest on ₹12,000 for 2 years at 12% per annum, compounded annually?",
    options: ["A. ₹3,052.80", "B. ₹2,880", "C. ₹3,000", "D. ₹3,120"],
    answer: "A"
  },
  {
    id: 88,
    question: "A 180 m long train crosses a platform of length 120 m in 20 seconds. Find the speed of the train in km/hr.",
    options: ["A. 48 km/hr", "B. 54 km/hr", "C. 50 km/hr", "D. 56 km/hr"],
    answer: "B"
  },
  {
    id: 89,
    question: "In a survey of 500 people, 65% prefer tea, 45% prefer coffee, and 20% prefer both. How many people prefer neither tea nor coffee?",
    options: ["A. 50", "B. 55", "C. 60", "D. 45"],
    answer: "A"
  },
  {
    id: 90,
    question: "The variance of a data set is 25. If every observation is multiplied by 3, what will be the new standard deviation?",
    options: ["A. 15", "B. 25", "C. 45", "D. 75"],
    answer: "A"
  },
  {
    id: 91,
    question: "If x − 1/x = 4, find the value of x² + 1/x².",
    options: ["A. 16", "B. 18", "C. 14", "D. 20"],
    answer: "B"
  },
  {
    id: 92,
    question: "A bag contains 4 red, 5 blue, and 3 green balls. If one ball is drawn at random, what is the probability that it is not blue?",
    options: ["A. 5/12", "B. 7/12", "C. 1/3", "D. 2/3"],
    answer: "B"
  },
  {
    id: 93,
    question: "A alone can complete a task in 18 days and B alone in 24 days. They work together for 6 days, after which A leaves. In how many more days will B complete the remaining work?",
    options: ["A. 10 days", "B. 11 days", "C. 12 days", "D. 9 days"],
    answer: "A"
  },
  {
    id: 94,
    question: "The following table shows marks scored by 100 students. Find the number of students scoring below 60. Marks range: 0-20 (10), 20-40 (18), 40-60 (27), 60-80 (30), 80-100 (15)",
    options: ["A. 45", "B. 55", "C. 60", "D. 65"],
    answer: "B"
  },
  {
    id: 95,
    question: "Two dice are rolled together. What is the probability that the sum of the numbers is either 7 or 11?",
    options: ["A. 6/36", "B. 8/36", "C. 2/9", "D. 1/6"],
    answer: "B"
  },
  {
    id: 96,
    question: "A father's present age is 5 times his son's age. Six years hence, the father's age will be 3 times his son's age. Find the son's present age.",
    options: ["A. 6 years", "B. 8 years", "C. 10 years", "D. 12 years"],
    answer: "A"
  },
  {
    id: 97,
    question: "The area of a rectangular field is 5,400 sq. m and its length is 1.5 times its breadth. Find the perimeter of the field.",
    options: ["A. 300 m", "B. 310 m", "C. 320 m", "D. 290 m"],
    answer: "A"
  },
  {
    id: 98,
    question: "A shopkeeper allows a 10% discount on the marked price of an item and still makes a profit of 8%. If the cost price is ₹500, find the marked price.",
    options: ["A. ₹600", "B. ₹580", "C. ₹610", "D. ₹590"],
    answer: "A"
  },
  {
    id: 99,
    question: "If 15 workers can complete a project in 20 days, how many additional workers are needed to complete the same project in 12 days?",
    options: ["A. 10", "B. 12", "C. 15", "D. 18"],
    answer: "A"
  },
  {
    id: 100,
    question: "The sum of the squares of three consecutive natural numbers is 302. Find the middle number.",
    options: ["A. 9", "B. 10", "C. 11", "D. 8"],
    answer: "B"
  }
 
];
 
export default pgcetmbaGeneralKnowledge;